import React from 'react';
import styles from './MainSlider.module.scss';

const MainSliderPagination = ({ children, ...rest }) => {
  return (
    <div className={styles.pagination} {...rest}>
      {children}
    </div>
  );
};

export default MainSliderPagination;
